import { IconChevronsLeft, IconChevronsRight } from "@/assets/icons";
import { START_PAGE } from "@/constants/pagination";
import { useAdminUserFilterCache } from "@/features/system-settings/providers/AdminUserListFilterCacheProvider";
import { background, button, divider, text } from "@/theme/colors";
import { elevation } from "@/theme/variables";
import { isNumber, toNumber } from "@/utils/number";
import { Box, Pagination as MuiPagination, PaginationItem, Stack, styled } from "@mui/material";
import { FC, useEffect, useState } from "react";

type Props = {
  totalPage?: number;
};

export const AdminUserListPagination: FC<Props> = ({ totalPage }) => {
  const { filterCache, setFilterCache } = useAdminUserFilterCache();

  const page = parseInt(filterCache.page?.toString() || START_PAGE.toString());

  const [displayTotalPage, setDisplayTotalPage] = useState<number>(1);

  useEffect(() => {
    if (isNumber(totalPage)) {
      setDisplayTotalPage(totalPage > 0 ? totalPage : 1);
    }
  }, [totalPage]);

  const handleClickPagination = (newPage: number) => {
    setFilterCache({ ...filterCache, page: newPage });
  };

  return (
    <Stack direction="row" alignItems="center" gap={2.5}>
      <StyledPagination
        page={page}
        count={displayTotalPage}
        variant="outlined"
        shape="rounded"
        showFirstButton
        showLastButton
        renderItem={(item) => (
          <PaginationItem
            slots={{ first: IconChevronsLeft, last: IconChevronsRight }}
            {...item}
            size="large"
            component={Box}
            onClick={() => handleClickPagination(toNumber(item.page))}
          />
        )}
      />
    </Stack>
  );
};

const StyledPagination = styled(MuiPagination)`
  .MuiPaginationItem-root {
    border-radius: 6px;
    margin: 0 4px;
    box-shadow: ${elevation.sm};
    border-color: ${divider.middle};
    color: ${text.secondary};
  }

  .Mui-disabled {
    color: ${text.disable};
    background-color: ${background.disable};
    opacity: 1 !important;
  }

  .Mui-selected:hover {
    cursor: default;
    color: ${text.white};
    background-color: ${background.main} !important;
  }

  li:has(> .MuiPaginationItem-previousNext) + li > .MuiPaginationItem-page {
    margin-left: 18px;
  }

  li:has(+ li > .MuiPaginationItem-previousNext) > .MuiPaginationItem-page {
    margin-right: 18px;
  }

  .Mui-selected {
    background-color: ${button.primary} !important;
    color: ${text.white};
  }
`;
